module.exports = __webpack_public_path__ + "img/reporting_posts_content.36c4dfa4.svg";